<template>
  <div class="search-main">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#fff"
      text-color="#000"
      active-text-color="#1b66e6"
    >
      <el-menu-item index="1">全文检索</el-menu-item>
      <el-menu-item index="2">高级检索</el-menu-item>
    </el-menu>
    <AdvancedRetrieval v-if="activeIndex == '2'"></AdvancedRetrieval>
    <FullTextRetrieval v-if="activeIndex == '1'"></FullTextRetrieval>
  </div>
</template>

<script>
import AdvancedRetrieval from "./HomePage1.vue";
import FullTextRetrieval from "./HomePage.vue";

export default {
  components: {
    FullTextRetrieval,
    AdvancedRetrieval,
  },
  data() {
    return {
      activeIndex: "1",
      // showSeniorResultPage: false,
      // seniorSearchData: {},
    };
  },
  methods: {
    // seniorSearch(val) {
    //   this.showSeniorResultPage = true;
    //   this.seniorSearchData = val;
    //   // console.log(val);
    // },
    handleSelect(key) {
      this.activeIndex = key;
      // this.showSeniorResultPage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-main {
  height: calc(100% );
}
.el-menu.el-menu--horizontal {
  border-bottom: 1px solid rgb(27, 102, 230) !important;
}

.el-menu-item:hover {
  background-color: rgba(137, 220, 226, 0.3) !important;
}
.el-menu {
  background-color: transparent !important;
 }
 .is-active:hover {
  background-color: transparent !important;
 }
 
 .el-menu-item{
    background-color: transparent !important;
    color: white !important;
 }
 .is-active {
  color: rgb(27, 102, 230) !important;
 }
</style>
